import { HttpClient } from '@angular/common/http';
import * as Routes from 'src/Routes';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PositionService {

  constructor(private http: HttpClient) { }

  add(formData: FormData): Promise<any> {
    return this.http.post<any>(Routes.POSITION, formData).toPromise();
  }

  update(formData: FormData, id): Promise<any> {
    return this.http.post<any>(`${Routes.POSITION}/${id}`, formData).toPromise();
  }

  delete(id: number) {
    return this.http.delete(`${Routes.POSITION}/${id}`).toPromise();

  }

  find(id: number): Promise<any> {
    return this.http.get<any>(`${Routes.POSITION}/${id}`).toPromise();
  }

  public gets(page) {
    return this.http.get<any>(`${Routes.POSITION}?page=${page}`)
      .toPromise();
  }

  public get(url) {
    return this.http.get<any>(`${url}`)
      .toPromise();
  }

  public getModel() {
    return this.http.get<any>(`${Routes.FORM}`)
      .toPromise();
  } 

  public getPosModel(id) {
    return this.http.get<any>(`${Routes.POSITION}/getPosition/${id}`)
    .toPromise();
  }

}
